module.exports = __webpack_public_path__ + "media/images/icon_message_white-64c8fdb08e9ed2bd23f8587ea13512b5.png";